import React from 'react';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import uuid from 'uuid/v1';

import { isEmpty, map, isEqual } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import { Box, Stack, Typography, IconButton, Alert } from '@mui/material';

import FullscreenIcon from '@mui/icons-material/Fullscreen';
import * as materialMui from '../../MaterialMUIComponent';
import Loading from '../../Loading';

import TelemetryConnections from '../../../../api/TelemetryConnections/TelemetryConnections';

import * as templateOps from '../../../../api/AnnotationTemplates/annotation-template-operations';

import OpenModalFromUrl from '../../OpenModalFromUrl';

const DATA_BASE = {
  host: '146.59.69.180',
  port: 30038,
  database: 'lidarand',
  user: 'postgres',
  password: 'pg',
  esquema: 'produccion',
  tabla: 'configuration'
};

const TemplateCatastroItem = ({
  serverConnection,
  loading,
  elementItem,
  updateAnnotationFields,
  updatedAnnotation,
  selectedAnnotation,
  previewMode,
  viewBasicEditMultis
}) => {
  if (loading) return <Loading />;

  const [connectionSchema, setConnectionSchema] = React.useState(
    templateOps.getElementConnections(elementItem)
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [openModalFullScreen, setOpenModalFullScreen] = React.useState(false);

  const urlCall = server => {
    let url;
    if (server.serverType === 'IGP') {
      url = `http://${server.ip}:${server.port}/MG/lidar/exec_filter_lidar`;
    } else if (server.serverType === 'IGPS' || server.serverType === 'input') {
      url = `${server.domain}/MG/lidar/exec_filter_lidar`;
    }
    return url;
  };

  const callToBack = async server => {
    setIsLoading(true);
    let coords = [];
    try {
      if (!isEmpty(updatedAnnotation)) {
        coords = updatedAnnotation.geoJSON.geometry.coordinates;
      } else if (!isEmpty(selectedAnnotation)) {
        coords = selectedAnnotation.geoJSON.geometry.coordinates;
      }
      if (!isEmpty(coords)) {
        const response = await fetch(urlCall(server), {
          method: 'POST',
          body: JSON.stringify({
            coordSystem: 'EPSG:4326',
            dataBase: DATA_BASE,
            inputFile: '',
            mongo: [],
            point: [coords[1], coords[0]],
            user: null,
            tableId: '',
            tableFilter: '',
            typeGeometry: 'catastro',
            typeFile: []
          }),
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        });
        const catastroInfo = await response.json();
        if (!isEmpty(catastroInfo.message) || catastroInfo.type === 'ERROR') {
          setConnectionSchema({ ...connectionSchema, server, source: {} });
        } else {
          setConnectionSchema({ ...connectionSchema, server, source: catastroInfo });
          updateAnnotationFields(elementItem, 'connections', {
            ...connectionSchema,
            server,
            source: catastroInfo
          });
          Bert.alert('Data successfully downloaded', 'success');
        }
      }
    } catch (error) {
      Bert.alert('No data found', 'danger');
    }
    setIsLoading(false);
  };

  const renderInfoCatastro = () =>
    map(
      [
        `Cadastral reference: ${connectionSchema.source.name}`,
        `Information: ${connectionSchema.source.information}`,
        `lat: ${connectionSchema.source.point[0]}, lng: ${connectionSchema.source.point[1]}`
      ],
      item => <Typography key={item}>{item}</Typography>
    );

  const renderManySelect = array =>
    map(array, item =>
      materialMui.renderSelect({
        key: item.value || uuid(),
        label: item.label,
        inputLabel: item.label,
        value: item.value,
        onChange: item.function,
        arrayOptions: item.options
      })
    );

  return (
    <>
      {isEqual(previewMode, 'preview') && !isEmpty(connectionSchema.source) && (
        <Box>
          <Stack alignitems="left">
            <Stack direction="row" display="flex" justifyContent="space-between">
              <h4>Land Registry</h4>
              <IconButton
                onClick={() => setOpenModalFullScreen(true)}
                style={{
                  color: '#2A3F90'
                }}
              >
                <FullscreenIcon />
              </IconButton>
            </Stack>

            {renderInfoCatastro()}
          </Stack>
          <Box sx={{ height: '100%', width: '90%', marginTop: '2%' }}>
            <iframe
              src={`https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?rc1=${connectionSchema.source.name.slice(
                0,
                7
              )}&rc2=${connectionSchema.source.name.slice(7)}`}
              style={{ border: 'none', width: '100%', height: '50vh' }}
              title="ViewLinks"
            />
          </Box>
          <OpenModalFromUrl
            isFullScreen
            openModal={openModalFullScreen}
            setOpenModal={setOpenModalFullScreen}
            title={!isEmpty(connectionSchema.source) ? connectionSchema.source.name : ''}
            url={`https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?rc1=${connectionSchema.source.name.slice(
              0,
              7
            )}&rc2=${connectionSchema.source.name.slice(7)}`}
          />
        </Box>
      )}
      {isEqual(previewMode, 'edition') && viewBasicEditMultis && (
        <>
          <Box>
            {renderManySelect([
              {
                label: 'IPS Connection',
                function: event => {
                  const fullServer = serverConnection.find(
                    element => element.name === event.target.value
                  );
                  callToBack(fullServer);
                },
                value: !isEmpty(connectionSchema.server) ? connectionSchema.server.name : 'none',
                options: ['none'].concat(map(serverConnection, item => item.name))
              }
            ])}

            {isLoading && <Loading />}
            {!isEmpty(connectionSchema.source) && (
              <Box>
                <Stack alignitems="left">
                  <h4>Land Registry</h4>
                  {renderInfoCatastro()}
                </Stack>
                <Box sx={{ height: '100%', width: '90%', marginTop: '2%' }}>
                  <iframe
                    src={`https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?rc1=${connectionSchema.source.name.slice(
                      0,
                      7
                    )}&rc2=${connectionSchema.source.name.slice(7)}`}
                    style={{ border: 'none', width: '100%', height: '100%' }}
                    title="ViewLinks"
                  />
                </Box>
              </Box>
            )}
            {isEmpty(connectionSchema.source) && !isEmpty(connectionSchema.server) && (
              <Alert severity="info">NO SE ENCUENTRA REFERENCIA CATASTRAL</Alert>
            )}
          </Box>
        </>
      )}
    </>
  );
};
TemplateCatastroItem.defaultProps = {
  updateAnnotationFields: () => console.error('no action to update'),
  updatedAnnotation: {},
  selectedAnnotation: {}
};

TemplateCatastroItem.propTypes = {
  serverConnection: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  updatedAnnotation: PropTypes.object,
  selectedAnnotation: PropTypes.object,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};

export default withTracker(() => {
  const connectionsSub = Meteor.isClient && Meteor.subscribe('telemetryConnections');
  const connectorsSub = Meteor.subscribe('connectors');

  return {
    loading: !connectionsSub.ready() && !connectorsSub.ready(),
    serverConnection: TelemetryConnections.find({ serverType: { $in: ['IGP', 'IGPS'] } }).fetch()
  };
})(TemplateCatastroItem);
